import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_UTM = "forex.utm";

/**
 * Fires one anonymous page-view record on every route change.
 * Captures: path, referrer, UTM params (persisted for the whole session),
 * language. Backend enriches with country + device + source classification.
 */
export default function VisitTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  // Capture UTM on first mount and persist for the session
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const utm = {
        utm_source: params.get("utm_source") || undefined,
        utm_medium: params.get("utm_medium") || undefined,
        utm_campaign: params.get("utm_campaign") || undefined,
      };
      if (utm.utm_source || utm.utm_medium || utm.utm_campaign) {
        sessionStorage.setItem(STORAGE_UTM, JSON.stringify(utm));
      }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    let utm = {};
    try { utm = JSON.parse(sessionStorage.getItem(STORAGE_UTM) || "{}"); } catch { /* ignore */ }
    const lang = (typeof document !== "undefined" && document.documentElement.lang) || navigator.language?.slice(0, 2) || "";
    axios.post(`${API}/track/visit`, {
      path: location.pathname,
      referrer: document.referrer || null,
      lang,
      ...utm,
    }).catch(() => { /* silent — never break the UI */ });
  }, [location.pathname]);

  return null;
}
